// extracted by mini-css-extract-plugin
module.exports = {"nav":"Nav_nav__KViWQ","active":"Nav_active__2puts"};